import { CcpaStatus } from "@inferno/renderer-shared-core";
import type { Store } from "../../../client/stores";

export function setBeacon(store: Store) {
  if (store.getCcpaStatus() === CcpaStatus.OptOut) {
    window.deferAnalyticsVendorBeacons = true;
  }
}
